/**
 * TestimonialsSection
 *
 * 3 testimonial cards from beta community members.
 * 3-column grid on desktop, single column on mobile.
 */

const testimonials = [
  {
    name: 'Beta tester',
    location: 'Austin, TX',
    quote:
      'My mom cried when she got the card. She said she hadn\'t gotten a real birthday card in years. I\'ve been the worst at this my whole adult life, MomentSent fixed it in five minutes.',
  },
  {
    name: 'Beta tester',
    location: 'Fayetteville, NC',
    quote:
      'Between work and kids, I completely checked out of remembering anniversaries. Our card landed in the mailbox right on the day, and my wife thought I planned it weeks ahead. I never lifted a finger.',
  },
  {
    name: 'Beta tester',
    location: 'Portland, OR',
    quote:
      'I added my whole family in one sitting, parents, siblings, kids, grandkids. Now I\'m the one who always remembers. That\'s never been me before.',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-cream py-20">
      <div className="section-container">

        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-navy mb-2">
            What our beta testers are saying
          </h2>
          <p className="font-body text-sm text-gray-400 mt-2">
            From our closed beta community, names withheld at their request.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="card bg-white rounded-card shadow-warm p-6 md:p-8 flex flex-col"
            >
              {/* Decorative opening quote */}
              <span
                className="text-sage font-heading leading-none mb-3 block"
                style={{ fontSize: 64, lineHeight: 1 }}
                aria-hidden="true"
              >
                &ldquo;
              </span>

              {/* Quote */}
              <p className="font-accent italic text-navy/80 text-base leading-relaxed flex-1 mb-6">
                {t.quote}
              </p>

              {/* Author */}
              <div>
                <p className="font-heading text-navy text-base mb-0.5">{t.name}</p>
                <p className="font-body text-gray-400 text-xs mb-2">{t.location}</p>
                <p className="text-gold tracking-wide" aria-label="5 out of 5 stars">
                  ★★★★★
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
